


























import { computed, defineComponent, ref, toRef, watch } from "@vue/composition-api";
import { throttle } from "lodash";
import { Location } from "vue-router";
import { User } from "@scrile/api-provider/dist/api/UserProvider";
import { UserPublicData } from "@scrile/api-provider/dist/api/UserPublicDataProvider";
import useAuthorisedOnly from "@/hooks/useAuthorisedOnly";
import providers from "@/lib/api";
import { MediaFilesController } from "@/lib/MediaFilesController";
import { getProfileUrl } from "@/lib/urlHelpers";
import config from "@/config";
import BaseIcon from "@/components/BaseIcon";

export default defineComponent({
  name: "ModelItem",
  components: { BaseIcon },
  props: {
    model: { type: Object as () => UserPublicData, required: true },
    followedIds: { type: Array as () => string[], required: true },
    authUser: { type: Object as () => User },
  },
  setup(props) {
    const online = computed<boolean>(
      () =>
        (config.featureUserOnlineStatus &&
          "onlineStatus" in props.model &&
          props.model.onlineStatus &&
          props.model.onlineStatus.isOnline) ||
        false
    );
    const isFollow = ref<boolean | null>(null);

    watch(
      toRef(props, "followedIds"),
      currentFollowedIds => {
        if (currentFollowedIds.length && isFollow.value === null) {
          isFollow.value = !!currentFollowedIds.find(item => item === props.model.id);
        }
      },
      { immediate: true }
    );

    const profileUrl = computed<Location>(() => getProfileUrl(props.model));
    const src = computed<string>(
      () =>
        (props.model.avatar && MediaFilesController.getImageThumbnail(props.model.avatar.urlPart, "720p")) ||
        "img/profile-placeholder.png"
    );

    const isAuthor = computed(() => {
      return props.authUser?.id === props.model.id;
    });

    const onFollowToggle = useAuthorisedOnly(
      throttle(async () => {
        isFollow.value = await providers.FollowingsProvider.toggle({ id: props.model.id });
      }, 500),
      props.model.id
    );

    const live = computed<boolean>(() => "publicLivechatUser" in props.model && !!props.model.publicLivechatUser);
    return { online, live, profileUrl, src, onFollowToggle, isFollow, isAuthor };
  },
});
